// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2CG4p","upload":"Small_upload__30YyE","imageWrap":"Small_imageWrap__XbJvv","removeBtn":"Small_removeBtn__3d08v"};